import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getAreasDesarrolloThunk } from "../store/reducers/fortalezas/fortalezas.thunks";
import AreasHeader from "./fortalezas/AreasHeader";
import AreasTable from "./fortalezas/AreasTable";
import AreaViewModal from "./fortalezas/AreaViewModal";
import AreaFormModal from "./fortalezas/AreaFormModal";
import ConfirmToggleAreaModal from "./fortalezas/ConfirmToggleAreaModal";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import EmptyState from "./UI/EmptyState";
import {
  clearAreasError,
  setAreasPage,
} from "../store/reducers/fortalezas/fortalezas.reducer";

const FortalezasAreasListLayer = () => {
  const dispatch = useDispatch();
  const {
    areasList,
    areasLoading,
    areasError,
    areasPage,
    areasPageSize,
    areasSearch,
    areasCount,
  } = useSelector((state) => state.fortalezas);

  useEffect(() => {
    dispatch(getAreasDesarrolloThunk({ page: areasPage, search: areasSearch }));
  }, [dispatch, areasPage, areasSearch]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <AreasHeader />

        {areasError && (
          <Alert
            message={areasError}
            variant="error"
            onClose={() => dispatch(clearAreasError())}
          />
        )}

        {areasLoading ? (
          <Loader center text="Cargando áreas de desarrollo..." delay={200} />
        ) : (
          <>
            {areasSearch && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {areasCount > 0 ? (
                    <>
                      Se {areasCount === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{areasCount}</strong>{" "}
                      {areasCount === 1 ? "resultado" : "resultados"} para "
                      {areasSearch}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{areasSearch}"</>
                  )}
                </span>
              </div>
            )}

            {areasList.length === 0 ? (
              <EmptyState
                icon={areasSearch ? "mdi:magnify-remove-outline" : "mdi:shape-outline"}
                title={areasSearch ? "No se encontraron áreas" : "No hay áreas de desarrollo registradas"}
                description={areasSearch ? "Intenta con otra búsqueda" : "Las áreas se gestionan desde el panel de administración"}
              />
            ) : (
              <>
                <AreasTable areas={areasList} search={areasSearch} />
                <Pagination
                  page={areasPage}
                  count={areasCount}
                  pageSize={areasPageSize}
                  onPageChange={(newPage) => dispatch(setAreasPage(newPage))}
                />
              </>
            )}
          </>
        )}
      </div>

      <AreaViewModal />
      <AreaFormModal />
      <ConfirmToggleAreaModal />
    </div>
  );
};

export default FortalezasAreasListLayer;
